// src/store/thunks/sixCatalog/setSortAndFetchThunk.ts

import type { MappedSixesCatalogResponse } from '@/store/mappers/sixCatalog';
import type { CatalogSortField, CatalogSortDirection } from '@/types/SixCatalogDTOs';
import { setSort } from '@/store/slices/sixCatalog/sixCatalogSlice';
import { refreshSixCatalogThunk } from '@/store/thunks/sixCatalog/refreshSixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

/**
 * Sets the sort parameters in state and fetches the updated catalog.
 * Uses the silent refresh (no global loader) — the list re-sorts client-side
 * immediately, so the fetch is a background reconciliation.
 * Returns the mapped catalog response for proper thunk typing.
 */
export const setSortAndFetchThunk = createAppAsyncThunk<
  MappedSixesCatalogResponse,
  { sortField: CatalogSortField; sortDirection: CatalogSortDirection }
>(
  'catalog/setSortAndFetch',
  async({ sortField, sortDirection }, { dispatch, getState }) => {
    dispatch(setSort({ sortField, sortDirection }));
    const { filters, search } = getState().sixCatalog;
    return await dispatch(
      refreshSixCatalogThunk({ filters, search, sortField, sortDirection })
    ).unwrap();
  }
);
